import { useSyncExternalStore } from "react";
import { storageKey } from "@/site";

// Device-local by design (D14): a nickname never leaves the device.
export const nicknameKey = (readerId: string): string =>
  storageKey(`nickname.v1:${readerId}`);

const listeners = new Set<() => void>();

export function readNickname(readerId: string): string | null {
  try {
    return localStorage.getItem(nicknameKey(readerId));
  } catch {
    return null;
  }
}

/** False when storage refused the write (Safari private mode). */
export function writeNickname(readerId: string, nickname: string): boolean {
  try {
    localStorage.setItem(nicknameKey(readerId), nickname);
  } catch {
    return false;
  }
  for (const listener of listeners) listener();
  return true;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  window.addEventListener("storage", listener);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", listener);
  };
}

export function useNickname(readerId: string): string | null {
  return useSyncExternalStore(
    subscribe,
    () => readNickname(readerId),
    () => null,
  );
}
